<template>
  <div class="discount-infobox">{{ text }}</div>
</template>

<script>
export default {
  name: "DiscountInfobox",
  props: {
    text: String,
  },
};
</script>

<style scoped lang="scss">
.discount-infobox {
  display: inline-block;
  color: $brand-green;
  border: 3px dashed $brand-green;
  border-radius: $border-radius-small;
  background-color: white;
  padding: 0.8rem 1.2rem;
  margin-bottom: 1.5rem;
  font-size: $small-font-size;
  font-weight: $font-bold;
  white-space: pre-wrap;
}
</style>
